import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import TradingHero from "./sections/TradingHero";
import Contact from "./sections/Contact";
import WeChatConnect from "./sections/WeChatConnect";
import Faq from "./sections/Faq";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <TradingHero />
      <Contact />
      <WeChatConnect />
      <Faq />
      <Footer />
    </div>;
}